import React, { CSSProperties } from "react";
import { Input } from "reactstrap";
import { ListItem } from "../app/types";

interface Props {
    name?: string;
    value?: string;
    items: ListItem[];
    showEmptyRow?: boolean;
    placeholder?: string;
    onChange: (value?: string) => void;
    disabled?: boolean;
    style?: CSSProperties;
    className?: string;
    onBlur?: () => void;
}

export default function Dropdown({
    name,
    value,
    items,
    showEmptyRow = true,
    placeholder,
    onChange,
    disabled,
    style,
    className,
    onBlur,
}: Props) {
    return (
        <Input
            style={style}
            name={name}
            type="select"
            value={value || ""}
            onChange={(e) => onChange(e.target.value || undefined)}
            disabled={disabled}
            className={className}
            onBlur={onBlur}
        >
            {showEmptyRow && <option value="">{placeholder ? ` --${placeholder}--` : ""}</option>}
            {items.map((i) => (
                <option key={i.key} value={i.key}>
                    {i.value}
                </option>
            ))}
        </Input>
    );
}
